'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

EwSiteApp.controller('EsoRrCtrl', [
	'$scope', '$http', '$filter', '$uibModal', '$log',
	function ($scope, $http, $filter, $uibModal, $log) {
		$scope.dataUrl = '';
		$scope.storeUrl = '';
		$scope.items = [];
		$scope.filtered_items = [];
		$scope.sortField = 'created';
		$scope.sortReverse = true;
		$scope.currentPage = 1;
		$scope.itemsPerPage = 20;
		$scope.totalItems = 0;
		$scope.numPages;
		$scope.filter = {};
		$scope.isFilters = false;
		$scope.cars = [];
		$scope.carsUrl = '';
		$scope.offices = [];
		$scope.officesUrl = '';
		$scope.problems = [];
		$scope.problemsUrl = '';

		$scope.is_eso_user = false;
		$scope.is_provider_user = false;
		$scope.is_office_user = false;
		$scope.car_was_issued = false;

		$scope.loadData = function () {
			if ($scope.dataUrl !== '') {
				$http({method: 'GET', url: $scope.dataUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof data.success !== 'undefined') {
								if (data.success) {
									if (angular.isDefined(data.list)) {
										$scope.items = data.list;
										$scope.totalItems = $scope.items.length;

										$scope.is_eso_user = data.is_eso_user;
										$scope.is_provider_user = data.is_provider_user;
										$scope.is_office_user = data.is_office_user;
									}
								} else if (angular.isDefined(data.message)) {
									$scope.ewMessages.add(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							}
						})
						.catch(function (err) {
							$log.error('loadData failed', err);
						});
			}
		};

		$scope.loadCars = function () {
			if ($scope.carsUrl !== '') {
				$http({method: 'GET', url: $scope.carsUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof data.success !== 'undefined') {
								if (data.success) {
									$scope.cars = data.list;
									for (var i in $scope.cars) {
										if ($scope.cars[i].filtered) {
											$scope.filter.car_id = $scope.cars[i].id;
											setTimeout(function () {
												if ($('#car_filter').length) {
													$('#car_filter').val($scope.filter.car_id).trigger('change');
												}
											}, 20);
											$scope.setFilters();
										}
									}
								}
							}
						})
						.catch(function (err) {
							$log.error('loadCars failed', err);
						});
			}
		};

		$scope.loadOffices = function () {
			if ($scope.officesUrl !== '') {
				$http({method: 'GET', url: $scope.officesUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof data.success !== 'undefined') {
								if (data.success) {
									$scope.offices = data.list;
								}
							}
						})
						.catch(function (err) {
							$log.error('loadOffices failed', err);
						});
			}
		};

		$scope.loadProblems = function () {
			if ($scope.problemsUrl !== '') {
				$http({method: 'GET', url: $scope.problemsUrl})
						.then(function (response) {
							var data = response.data;
							if (typeof data.success !== 'undefined') {
								if (data.success) {
									$scope.problems = data.list;
								}
							}
						})
						.catch(function (err) {
							$log.error('loadProblems failed', err);
						});
			}
		};

		$scope.addEntry = function () {
			var new_entry = {id: 0};
			$scope.editor(new_entry);
		};
		$scope.editEntry = function (entry) {
			$scope.editor(entry);
		};

		$scope.editor = function (item) {
			var modalInstance = $uibModal.open({
				templateUrl: 'esorr/repairdata.html',
				controller: 'EsoRrEditCtrl',
				size: 'lg',
				resolve: {
					item: function () {
						return item;
					},
					filter: function () {
						return angular.copy($scope.filter);
					},
					cars: function () {
						return angular.copy($scope.cars);
					},
					offices: function () {
						return angular.copy($scope.offices);
					},
					problems: function () {
						return angular.copy($scope.problems);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if ($scope.storeUrl !== '') {
					$http({
						method: 'POST',
						url: $scope.storeUrl,
						data: result,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					})
							.then(function (response) {
								var data = response.data;
								if (data.success && !angular.isUndefined(data.item)) {
									if (angular.isUndefined(item.id) || item.id < 1) {
										$scope.loadData();
									} else {
										angular.extend(item, data.item);
									}
								} else if (angular.isDefined(data.message)) {
									$scope.ewMessages.add(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							})
							.catch(function (err) {
								$log.error('store failed', err);
							});
				} else {
					$log.warn('No URL! url_template: ' + $scope.storeUrl);
				}
			}).catch(function (reason) {
				$log.debug('Repair editor modal dismissed:', reason);
			});
		};

		$scope.getPageList = function () {
			var ordered = $filter('filter')($scope.items, $scope.filter);
			$scope.totalItems = ordered.length;
			ordered = $filter('orderBy')(ordered, $scope.sortField, $scope.sortReverse);
			var start = ($scope.currentPage - 1) * $scope.itemsPerPage;
			var end = start + $scope.itemsPerPage;
			return ordered.slice(start, end);
		};

		$scope.cleanFilters = function () {
			$scope.filter = {car_id: '', office_id: ''};
			$scope.setFilters();
			setTimeout(function () {
				if ($('#car_filter').length) {
					$('#car_filter').val('').trigger('change');
				}
				if ($('#office_filter').length) {
					$('#office_filter').val('').trigger('change');
				}
			}, 200);
		};

		$scope.setFilters = function () {
			$scope.isFilters = false;
			for (var i in $scope.filter) {
				if ($scope.filter[i] != '') {
					$scope.isFilters = true;
				}
			}
		};

		$scope.preview = function (item) {
			$scope.previewEditor(item);
		};

		$scope.previewEditor = function (item) {
			var modalInstance = $uibModal.open({
				templateUrl: 'esorr/repairpreview.html',
				controller: 'EsoRrPreviewCtrl',
				size: 'lg',
				resolve: {
					item: function () {
						return item;
					},
					is_eso_user: function () {
						return angular.copy($scope.is_eso_user);
					},
					is_provider_user: function () {
						return angular.copy($scope.is_provider_user);
					},
					is_office_user: function () {
						return angular.copy($scope.is_office_user);
					},
					car_was_issued: function () {
						return angular.copy($scope.car_was_issued);
					}
				}
			});

			modalInstance.result.then(function (result) {
				if (item.save_url !== '') {
					$http({
						method: 'POST',
						url: item.save_url,
						data: result,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					})
							.then(function (response) {
								var data = response.data;
								if (data.success && !angular.isUndefined(data.item)) {
									$scope.loadData();
								} else if (angular.isDefined(data.message)) {
									$scope.ewMessages.add(data.message);
								}
								if (angular.isDefined(data.debug)) {
									$log.debug(data.debug);
								}
							})
							.catch(function (err) {
								$log.error('preview save failed', err);
							});
				} else {
					$log.warn('No URL! url_template: ' + item.save_url);
				}
			}).catch(function (reason) {
			});
		};
	}
]).directive('remontsList', ['AddNewAction', function (AddNewAction) {
				return {
					restrict: 'A',
					link: function (scope, element, attr) {
						scope.dataUrl = '';
						scope.storeUrl = '';
						scope.carsUrl = '';
						scope.officesUrl = '';
						scope.problemsUrl = '';
						scope.itemsPerPage = 20;

						if (angular.isDefined(attr.dataUrl) && attr.dataUrl !== '') {
							scope.dataUrl = unescape(attr.dataUrl);
						}
						if (angular.isDefined(attr.carsUrl) && attr.carsUrl !== '') {
							scope.carsUrl = unescape(attr.carsUrl);
							scope.loadCars();
						}
						if (angular.isDefined(attr.officesUrl) && attr.officesUrl !== '') {
							scope.officesUrl = unescape(attr.officesUrl);
							scope.loadOffices();
						}
						if (angular.isDefined(attr.problemsUrl) && attr.problemsUrl !== '') {
							scope.problemsUrl = unescape(attr.problemsUrl);
							scope.loadProblems();
						}
						if (angular.isDefined(attr.storeUrl) && attr.storeUrl !== '') {
							scope.storeUrl = unescape(attr.storeUrl);
							AddNewAction.action = function () {
								scope.addEntry();
							};
						}
						if (attr.itemsPerPage && attr.itemsPerPage !== '' && attr.itemsPerPage > 0) {
							scope.itemsPerPage = parseInt(attr.itemsPerPage, 10);
						}
						scope.loadData();
					}
				};
			}]);

EwSiteApp.controller('EsoRrEditCtrl', [
	'$scope', '$uibModalInstance', 'item', 'filter', 'cars', 'offices', 'problems',
	function ($scope, $uibModalInstance, item, filter, cars, offices, problems) {
		$scope.require = {
			car_id: true,
			office_id: true
		};

		$scope.item = angular.copy(item);
		$scope.cars = cars;
		$scope.car_id = 0;
		$scope.offices = offices;
		$scope.offices_select = $scope.offices;
		$scope.office_id = 0;
		$scope.problems = problems;
		$scope.problems_select = $scope.problems;
		$scope.problem_id = [];
		$scope.filter = filter;

		if (typeof $scope.filter.car_id != 'undefined') {
			$scope.item.car_id = $scope.filter.car_id;
		}

		setTimeout(function () {
			if ($('#car_select').length) {
				$('#car_select').select2({});
			}
			if ($('#problems_select').length) {
				$('#problems_select')
						.select2({})
						.on('select2:selecting', function (e) {
							if (e.params.args.data.id == '') {
								e.preventDefault();
								$('#problems_select').select2('close');
							}
						});
				$('#problems_select')
						.select2({})
						.on('select2:opening', function () {
							$('.select2-selection--multiple').addClass('opened');
						});
				$('#problems_select')
						.select2({})
						.on('select2:closing', function () {
							$('.select2-selection--multiple').removeClass('opened');
						});
			}
			if ($('#office_select').length) {
				$('#office_select').select2({
					minimumResultsForSearch: -1
				});
			}
		}, 200);

		$scope.save = function () {
			$scope.submitted = true;
			if ($scope.classifiededitor.$valid) {
				$uibModalInstance.close($scope.item);
			}
		};
		$scope.cancel = function () {
			for (var i in $scope.require) {
				$scope.require[i] = false;
			}
			$uibModalInstance.dismiss('cancel');
		};
	}
]);

EwSiteApp.service('AddNewAction', [function () {
		this.action;
		var self = this;
		this.doAdd = function () {
			if (!angular.isUndefined(self.action)) {
				self.action();
			}
		};
	}]);

EwSiteApp.controller('EsoRrPreviewCtrl', [
	'$scope', '$uibModalInstance', 'item', 'is_eso_user', 'is_provider_user', 'is_office_user', 'car_was_issued',
	function ($scope, $uibModalInstance, item, is_eso_user, is_provider_user, is_office_user, car_was_issued) {
		$scope.item = angular.copy(item);

		$scope.is_eso_user = is_eso_user;
		$scope.is_provider_user = is_provider_user;
		$scope.is_office_user = is_office_user;
		$scope.car_was_issued = car_was_issued;

		$scope.templates = {
			status_0: 'esorr/storeamount.html',
			status_5: 'esorr/estimatedamount.html',
			status_10: 'esorr/storedeliverytime.html',
			status_20: 'esorr/changestatusvykdoma.html',
			status_21: 'esorr/storerepairsum.html',
			status_25: 'esorr/repairdone.html', // pickupcar
			status_30: 'esorr/repairdone.html',
		};

		$scope.getDataTemplate = function () {
			$scope.car_was_issued = item.replacement_car;
			var tpl = 'status_' + $scope.item.status;
			return $scope.templates[tpl];
		};

		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');	
		};
	}
]);
